import Clipboard from 'v-clipboard'; // https://www.npmjs.com/package/v-clipboard
import dayjs from 'dayjs';
import Dayjs from 'vue-dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore.js';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter.js';
import utc from 'dayjs/plugin/utc.js';
import Vue from 'vue';
import VueResource from 'vue-resource';
import VueRouter from 'vue-router';
import VueTextareaAutosize from 'vue-textarea-autosize';
import VueTippy, { TippyComponent } from 'vue-tippy';
import App from './App.vue';
import { AppUsageTracker } from './resources/app-usage.js';
import { i18n } from './resources/i18n.js'; // https://kazupon.github.io/vue-i18n/
import { routes } from './resources/routes.js';
import { store } from './resources/store.js';
import { CONSTANTS } from './resources/constants.js';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'tippy.js/themes/light.css';

import AuthService from './resources/office365-auth.js';
import { VueResourceHeaders } from './resources/vue-resource.js';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(utc);


Vue.use(VueTippy);
Vue.component('tippy-component', TippyComponent);

Vue.use(VueRouter);
const router = new VueRouter({
    routes,
});

Vue.use(Clipboard);
Vue.use(Dayjs);
Vue.use(VueResource);
Vue.use(VueTextareaAutosize);
Vue.prototype.$AuthService = new AuthService();

Vue.http.interceptors.push((request, next) => {
    next((response) => {
        if (response.status === 401) {
            return Vue.prototype.$AuthService.refreshToken().then((newToken) => {
                const safeToken = typeof newToken === 'object' ? newToken.token : newToken;
                VueResourceHeaders.token = safeToken;
                request.headers.set('Authorization', `Bearer ${safeToken}`);
                return Vue.http(request);
            }).catch((error) => {
                console.error('[Auth] Error al refrescar el token:', error);
                Vue.prototype.$AuthService.logout();
                window.location.href = '/';
            });
        }
    });
});

new Vue({
    el: '#ProductsHomepage2AppPlaceHolder',
    i18n,
    store,
    router,
    render: (h) => h(App),
});

Vue.prototype.$usageTracker = new AppUsageTracker(CONSTANTS.AppDescriptor, null);
